import React from 'react';
import styled from 'styled-components';
import BaseModel from '../../BaseModal'; // Assuming path is correct
import { BaseButton } from '../../styles/ButtonStyles'; // Assuming path is correct
import { FlexWrapperCenterForDialog } from '../../styles/WrapperStyles'; // Assuming path is correct
import './Modal.css'; // Assuming this file exists and is needed

// Re-using the TextView from your base code
const TextView = styled.p`
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  color: #484848;
  text-align: center;
`;

// NEW: Styled component for the <select> dropdown
// It's designed to look similar to the RefIdInput it replaces.
const FilterSelect = styled.select`
  width: 100%;
  height: 55px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 0 15px;
  font-size: 16px;
  font-family: inherit; /* Inherits font from parent */
  color: #484848;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;

  /* Removes default OS styling and adds a custom arrow */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('data:image/svg+xml;utf8,<svg fill="black" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>');
  background-repeat: no-repeat;
  background-position: right 15px center;
`;

/**
 * A modal for selecting a filter from a dropdown.
 *
 * @param {object} props
 * @param {function} props.closeModal - Function to close the modal.
 * @param {string} props.modalText - The text to display as the modal's title.
 * @param {function} props.handleFilterSubmit - Callback function that receives the selected filter value.
 */
const FilterModal = (props) => {
    // 1. Define the 7 filter options
    const filterOptions = [
        'Scammer',
        'Solicitor/Sus',
        'Impersonation',
        'Abusive/Vulgar messages',
        'Many reports',
        'Inappropriate BIOS',
        'Explicit images',
        'Married'
    ];

    // 2. State to hold the currently selected filter value
    const [selectedFilter, setSelectedFilter] = React.useState(filterOptions[0]);

    return (
        <BaseModel closeModal={props.closeModal}>
            <FlexWrapperCenterForDialog className="modalTransfer">
                <TextView>{'Apply a Filter'}</TextView>

                {/* 3. The new dropdown replaces the text input */}
                <FilterSelect
                    value={selectedFilter}
                    onChange={e => setSelectedFilter(e.target.value)}
                >
                    {filterOptions.map((option, index) => (
                        <option key={index} value={option}>
                            {option}
                        </option>
                    ))}
                </FilterSelect>

                <BaseButton
                    onClick={() => {
                        // 4. On click, call the handler prop with the selected value
                        if (selectedFilter) {
                            props.handleButtonEvents(selectedFilter, selectedFilter);
                        }
                    }}
                >
                    Confirm
                </BaseButton>
            </FlexWrapperCenterForDialog>
        </BaseModel>
    );
};

export default FilterModal;